<template>
    <div class="row gfk-footer">
        <div class="gfk-footer__title">Powered by GfK Business Applications Amstelveen</div>
    </div>
</template>

<script>
	export default {
		name: 'gfk-footer'
	};
</script>
